import { render, staticRenderFns } from "./dataMenuList.vue?vue&type=template&id=04843ee0&scoped=true&"
import script from "./dataMenuList.vue?vue&type=script&lang=js&"
export * from "./dataMenuList.vue?vue&type=script&lang=js&"
import style0 from "./dataMenuList.vue?vue&type=style&index=0&id=04843ee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04843ee0",
  null
  
)

export default component.exports